import axios from "axios";

(function () {
    var popups,
        overlay,
        retryExtractResult,
        retryExtractForm,
        retryExtractResultMsg,
        retryExtractResultRetryBtn,
        reportDupForm,
        reportDupResult,
        reportDupResultMsg,
        reportDupResultRetryBtn,
        copyConfirmMsg,
        navItems,
        messageToasts,
        dropdowns,
        dropdown
    ;

    window.onload = init;

    // popup functions //

    function openRetryExtractResultPopup(data) {
        retryExtractForm.style.display="none";
        retryExtractResult.style.display="grid";
        if (data.code === 202 || data.code === 208) {
            retryExtractResultRetryBtn.style.display="none";
        }
        else {
            retryExtractResultRetryBtn.style.display="block";
        }
        if (!data.message) {
            retryExtractResult.querySelector("h3").innerHTML = "Archon Error";
            retryExtractResultMsg.innerHTML = "Archon is experiencing some internal issue.";
        }
        else {
            retryExtractResult.querySelector("h3").innerHTML = data.title;
            retryExtractResultMsg.innerHTML = data.message;
        }
    }

    function openReportDuplicateArchiveResultPopup(data) {
        reportDupForm.style.display="none";
        reportDupResult.style.display="grid";
        if (data.code === 200 || data.code === 202 || data.code === 208) {
            reportDupResultRetryBtn.style.display="none";
        }
        else {
            reportDupResultRetryBtn.style.display="block";
        }
        if (!data.message) {
            reportDupResult.querySelector("h3").innerHTML = "Archon Error";
            reportDupResultMsg.innerHTML = "Archon is experiencing some internal issue.";
        }
        else {
            reportDupResult.querySelector("h3").innerHTML = data.title;
            reportDupResultMsg.innerHTML = data.message;
        }
    }

    function showPopup(element) {
        // open popup and overlay
        overlay.classList.add("show-popup");
        element.classList.add("show-popup");
    }

    function closePopups() {
        // close popups and overlay
        overlay.classList.remove("show-popup");
        for (var i = 0; i < popups.length; i++) {
            popups[i].classList.remove("show-popup");
        }
    }

    // init functions //

    function initPopups() {
        popups = document.querySelectorAll(".popup");
        overlay = document.querySelector(".overlay");
        var status_filter = document.querySelector(".status-filter");
        var status_filter_openbtn = document.querySelector(".status-filter-openbtn");
        if (popups) {
            // prevent popups from propagating click events
            for (var i = 0; i < popups.length; i++) {
                popups[i].addEventListener("click", function (e) {
                    e.stopPropagation();
                }, false);
            }
        }
        if (overlay) {
            // close popups on overlay click
            overlay.addEventListener("click", function (e) {
                if (e.target.matches(".overlay")) {
                    closePopups();
                }
            }, false);
        }
        if (status_filter_openbtn) {
            // status filter popup
            status_filter_openbtn.addEventListener('click', function() {
                showPopup(status_filter);
            }, false);
        }
    }

    function initRetryExtract() {
        // retry extraction logic
        var retryExtractPopupInput = document.querySelector(".retry-extraction-form input");
        var retryExtractPopup = document.querySelector(".retry-extraction");
        var retryExtractPopupOpenBtns = document.querySelectorAll(".retry-extraction-popup-openbtn");
        var retryExtractResultCloseBtn = document.querySelector(".retry-extraction-result-btns .close-btn");
        // open retry extraction form on click
        if (retryExtractPopupOpenBtns) {
            for (var i = 0; i < retryExtractPopupOpenBtns.length; i++) {
                retryExtractPopupOpenBtns[i].addEventListener("click", function (e) {
                    e.stopPropagation();
                    e.preventDefault();
                    retryExtractForm.reset();
                    retryExtractForm.setAttribute("data-sha1", this.dataset.sha1);
                    retryExtractResult.style.display = "none";
                    retryExtractForm.style.display = "grid";
                    showPopup(retryExtractPopup);
                }, false);
            }
        }
        // send retry extraction submit event info to url
        if (retryExtractForm) {
            retryExtractForm.addEventListener("submit", function (e) {
                e.preventDefault();
                var formData = new FormData();
                formData.append("sha1", retryExtractForm.getAttribute("data-sha1"));
                formData.append("password", retryExtractPopupInput.value);
                var csrfToken = document.getElementById("middlewarecsrftoken").value;
                axios
                    .post(
                        "/archives/retry_extraction",
                        formData,
                        {"headers": {"X-CSRFToken": csrfToken, "Content-Type": "multipart/form-data"}}
                    )
                    .then(function (response) {
                        openRetryExtractResultPopup(response.data);
                    })
                    .catch(function (e) {
                        openRetryExtractResultPopup(e.response.data);
                    });
            }, false);
        }

        if (retryExtractResultCloseBtn) {
            retryExtractResultCloseBtn.addEventListener("click", closePopups, false);
        }
        if (retryExtractResultRetryBtn) {
            retryExtractResultRetryBtn.addEventListener("click", function(e) {
                e.stopPropagation();
                e.preventDefault();
                retryExtractForm.reset();
                retryExtractResult.style.display="none";
                retryExtractForm.style.display="grid";
            }, false);
        }
    }

    function initCopyables() {
        copyConfirmMsg = document.querySelector(".copy-confirm-msg");
        var copyables = document.querySelectorAll(".copyable");
        if (copyables) {
            for (var i = 0; i < copyables.length; i++) {
                copyables[i].addEventListener("click", function (e) {
                    e.stopPropagation();
                    e.preventDefault();
                    // copy to clipboard
                    if (this.dataset.copyvalue && this.dataset.copyvalue.length > 0) {
                        navigator.clipboard.writeText(this.dataset.copyvalue);
                        // display message
                        if (copyConfirmMsg) {
                            copyConfirmMsg.style.visibility = "visible";
                            copyConfirmMsg.style.opacity = 1;
                            copyConfirmMsg.style.left = e.clientX + 10 + "px";
                            copyConfirmMsg.style.top = e.clientY + 10 + "px";
                        }
                        // hide message after delay
                        setTimeout(function () {
                            copyConfirmMsg.style.visibility = "hidden";
                            copyConfirmMsg.style.opacity = 0;
                        }, 1800);
                    }
                }, false);
            }
        }
    }

    function initMessageToasts() {
        // handle the info toast
        messageToasts = document.querySelectorAll(".message-toast");
        if (messageToasts) {
            for (var i = 0; i < messageToasts.length; i++) {
                // Needed to do some odd looking js scoping to get the index to work correctly.
                // In essence, it defines a scoped function which takes 'i' and saves it as 'index' to make it
                // accessible and non-mutable. Since 'index' is accessible and non-mutable it can be used inside the
                // event listener with having it change during runtime.
                (function(index){
                    var toast = messageToasts[index];
                    // get the close button to add listener
                    var closeButton = toast.querySelector(".toast-close");
                    if (closeButton) {
                        closeButton.addEventListener("click", (e) => {
                            messageToasts[index].classList.add("u-hidden");
                        });
                    }
                })(i);

                // add 'opacity=0' to toast so that it disappears within a few seconds
                messageToasts[i].classList.add("opacity-0");
            }
        }
    }

    function initReportDupArchive() {
        let reportDupDocId = document.querySelector("#id_doc_id");
        let reportDupUrls = document.querySelector("#id_urls");
        let reportDupPopup = document.querySelector(".report-dup-popup");
        let reportDupFormOpenBtns = document.querySelectorAll(".report-dup-popup-openbtn");
        let reportDupResultCloseBtn = document.querySelector(".report-dup-result-btns .close-btn");

        if (reportDupFormOpenBtns) {
            for (let i=0; i < reportDupFormOpenBtns.length; i++) {
                reportDupFormOpenBtns[i].addEventListener("click", function(e) {
                    e.stopPropagation();
                    e.preventDefault();
                    reportDupForm.reset();
                    reportDupForm.setAttribute("data-sha1", this.dataset.sha1);
                    reportDupResult.style.display = "none";
                    reportDupForm.style.display = "grid";
                    showPopup(reportDupPopup);
                }, false);
            }
        }
        if (reportDupForm) {
            reportDupForm.addEventListener("submit", function(e) {
                e.preventDefault();
                let formData = new FormData();
                formData.append("sha1", reportDupForm.getAttribute("data-sha1"));
                formData.append("doc_id", reportDupDocId.value);
                formData.append("urls", reportDupUrls.value);
                let csrfToken = document.getElementById("middlewarecsrftoken").value;
                axios
                    .post(
                        "/archives/report_duplicate",
                        formData,
                        {"headers": {"X-CSRFToken": csrfToken, "Content-Type": "multipart/form-data"}}
                    ).then(function (response) {
                        openReportDuplicateArchiveResultPopup(response.data);
                    })
                    .catch(function (e) {
                        openReportDuplicateArchiveResultPopup(e.response.data);
                    });
            }, false);
        }

        if (reportDupResultCloseBtn) {
            reportDupResultCloseBtn.addEventListener("click", closePopups, false);
        }
        if (reportDupResultRetryBtn) {
            reportDupResultRetryBtn.addEventListener("click", function(e) {
                e.stopPropagation();
                e.preventDefault();
                reportDupResult.style.display="none";
                reportDupForm.style.display="grid";
            }, false);
        }
    }

    function initArchiveDropdowns() {
        let openDropdownBtns = document.querySelectorAll(".more-actions");
        dropdowns = document.querySelectorAll(".archive-actions-dropdown");
        if (openDropdownBtns) {
            openDropdownBtns.forEach((el) => {
                el.addEventListener('click', (e) => {
                    let activeSha1 = el.dataset.sha1;
                    for (let i = 0; i < dropdowns.length; i++) {
                        let activeDropdown = dropdowns[i]
                        if (activeDropdown.dataset.sha1 === activeSha1) {
                            dropdown = activeDropdown;
                            break;
                        }
                    }
                    if (dropdown) {
                        if (dropdown.classList.contains("display-block")) {
                            dropdown.classList.remove("display-block");
                        } else {
                            dropdown.classList.add("display-block");
                            dropdown.style.left = e.clientX - 205 + "px";
                            dropdown.style.top = e.clientY + "px";
                            document.body.addEventListener('click', removeDropdownEventHandler, true);
                        }
                    }
                }, false);
            });
        }

        function removeDropdownEventHandler(e) {
            if (dropdown && e.target !== dropdown) {
                dropdown.classList.remove('display-block');
                dropdown = null;
                document.body.removeEventListener('click', removeDropdownEventHandler);
            }
        }
    }

    function init() {
        retryExtractResult = document.querySelector(".retry-extraction-result");
        retryExtractForm = document.querySelector(".retry-extraction-form");
        retryExtractResultMsg = document.querySelector(".retry-extraction-result-msg");
        retryExtractResultRetryBtn = document.querySelector(".retry-extraction-result-btns .retry-btn");
        reportDupResult = document.querySelector(".report-dup-result");
        reportDupForm = document.querySelector(".report-dup-form");
        reportDupResultMsg = document.querySelector(".report-dup-result-msg");
        reportDupResultRetryBtn = document.querySelector(".report-dup-result-btns .retry-btn");


        var newTabLinks = document.querySelectorAll(".newtab-link");
        if (newTabLinks) {
            // open new tabs
            for (var i = 0; i < newTabLinks.length; i++) {
                newTabLinks[i].addEventListener("click", function (e) {
                    e.stopPropagation();
                    e.preventDefault();
                    window.open(this.getAttribute("href"), "_blank");
                }, false);
            }
        }

        initPopups();
        initRetryExtract();
        initCopyables();
        initMessageToasts();
        initReportDupArchive();
        initArchiveDropdowns();

        // handle keeping track of active navbar element
        navItems = document.querySelectorAll(".nav-item");
        if (navItems) {
            for (var i = 0; i < navItems.length; i++) {
                navItems[i].addEventListener("click", function(e) {
                    var currentActive = document.querySelector(".active");
                    if (currentActive) {
                        currentActive.classList.toggle("active");
                    }
                    this.classList.toggle("active");
                }, false);
            }
        }
    }


    // only runs when create archive form is on page
    let createArchiveForm = document.querySelector('#create-archive-form');
    if (createArchiveForm != null) {
        let sha1Field = document.querySelector('#id_sha1');
        let fileField = document.querySelector('#id_file');
        let submitButton = createArchiveForm.querySelector('button[type=submit]')

        // disable fields when other fields are active for the create archive form
        if (sha1Field != null && fileField != null) {
            // initialize with field disabling in case user gets error when submitting form
            if (sha1Field.value.length > 0) {
                fileField.disabled = true;
            } else if (fileField.value.disabled != null) {
                sha1Field.disabled = true;
            }
            sha1Field.addEventListener('input', () => {
                if (sha1Field.value.length > 0 && !fileField.disabled) {
                    fileField.disabled = true;
                    fileField.title = 'Cannot include a file if a SHA1 value is provided.';
                } else if (sha1Field.value.length === 0 && fileField.disabled) {
                    fileField.disabled = false;
                    fileField.title = '';
                }
            });
            fileField.addEventListener('input', () => {
                if (fileField.value != null && !sha1Field.disabled) {
                    sha1Field.disabled = true;
                    sha1Field.title = 'Cannot include a SHA1 if a file is provided.';
                } else if (fileField.value == null && sha1Field.disabled) {
                    sha1Field.disabled = false;
                    sha1Field.title = '';
                }
            });
            createArchiveForm.addEventListener('submit', () => {
                submitButton.disabled = true;
            })
            // if the form reset then re-enable the fields
            createArchiveForm.addEventListener('reset', () => {
                sha1Field.disabled = false;
                sha1Field.title = '';
                fileField.disabled = false;
                fileField.title = '';
                submitButton.disabled = false;
            });
        }
    }
})();